export enum FadeClasses {
  FADED_OUT = 'faded-out',
  FADE_IN_ANIMATION = 'fade-in-animation',
}
